import { createApp } from 'vue'
import App from './App.vue'
// import VConsole from 'vconsole';
import VueCookies from 'vue-cookies'
import { createPinia } from 'pinia'
import router from './router'
import 'virtual:uno.css'

import vant from 'vant'

import 'vant/lib/index.css'

const app = createApp(App)
// new VConsole();
app.use(VueCookies)
app.use(createPinia())
app.use(router)
app.use(vant)
app.mount('#app')